import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Container,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const COPYTRADINGSERVICE = "https://accounts.paybito.com/api/copyTrading";

const Columns = [
  "Key Name",
  "Exchange",
  "Market",
  "API Key",
  "Status",
  "Action",
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 600,
  width: "90%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 2,
  overflow: "auto",
  // Hide scrollbar
  scrollbarWidth: "none", // Firefox
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const ApiKey = () => {
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const [exchangeName, setExchangeName] = useState();
  const [market, setMarket] = useState("");

  const [open, setOpen] = useState(false);
  const [binancePopup, setBinancePopup] = useState(false);
  const [allApiKeys, setAllApiKeys] = useState([]);

  const [apiKeyName, setApiKeyName] = useState("");
  const [marketType, setMarketType] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [apiKeyId, setApiKeyId] = useState("");
  const [keyStatus, setKeyStatus] = useState(0);
  const [brokerMarkets, setBrokerMarkets] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    getAllApiKeys();
    getAllBrokerMarkets();
  }, []);

  const getAllApiKeys = () => {
    const userId =
      localStorage.getItem("userId") || localStorage.getItem("user_id");
    const accessToken = localStorage.getItem("access_token");

    const headers = {
      "Content-Type": "application/json",
      Authorization: `BEARER ${accessToken}`,
    };

    axios
      .get(`${COPYTRADINGSERVICE}/apiKey/getAllApiKey/${userId}`, { headers })
      .then((response) => {
        console.log("get all api keys", response.data.apiKeyList);
        setAllApiKeys(response.data.apiKeyList);
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  const handleClose = () => (
    setOpen(false),
    setExchangeName(""),
    setMarket(""),
    setApiKeyName(""),
    setApiKey(""),
    setSecretKey(""),
    setApiKeyId("")
  );

  const VALIDATION1 = (event) => {
    const regex = /^[ A-Za-z0-9_./,-]*$/;
    const { key } = event;

    // Allow control keys
    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) {
      return;
    }

    // Check if key is a single character and test it
    if (!regex.test(key)) {
      event.preventDefault(); // Block disallowed characters
    }
  };

  // VALIDATION2: Alpha-numerics, _ . / , + - =
  const VALIDATION2 = (event) => {
    const regex = /^[ A-Za-z0-9_./,-]*$/;
    const { key } = event;

    // Allow control keys
    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) {
      return;
    }

    // Check if key is a single character and test it
    if (!regex.test(key)) {
      event.preventDefault(); // Block disallowed characters
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (apiKeyId) {
      addApiKey("UPDATE");
    } else {
      addApiKey("INSERT");
    }
  };

  const resetFields = () => {
    setApiKey("");
    setApiKeyName("");
    setSecretKey("");
    setMarket("spot");
    setExchangeName("");
  };

  const addApiKey = (action) => {
    const addAPI = {
      apiKey,
      marketType: market,
      apiKeyName,

      secretKey,
      customerId:
        localStorage.getItem("userId") || localStorage.getItem("user_id"),
      status: 1,
      exchange_name: exchangeName === "BINANCE" ? "BINANCE" : "PAYBITO",
      action: action,
    };
    if (apiKeyId) {
      addAPI["apiKeyId"] = apiKeyId;
    }

    axios
      .post(`${COPYTRADINGSERVICE}/apiKey/addApiKey`, JSON.stringify(addAPI), {
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        if (res.error.error_data === 0) {
          handleClose();
          resetFields();
          showToast("success", res.error.error_msg);
          getAllApiKeys();
        } else {
          handleClose();
          resetFields();
          showToast("error", res.error.error_msg);
        }
        setApiKeyId("");
      })
      .catch((error) => {
        handleClose();
        resetFields();
        showToast("error", "An error occurred while adding the API key");
      });
  };

  const getAllBrokerMarkets = async () => {
    const BROKERID = localStorage.getItem("BROKERID");
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const inputObj = { brokerId: BROKERID, uuid: uuid };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/brokerCryptoMarket`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      setBrokerMarkets(response.data.brokerCryptoMarket);
    } catch (error) {
      console.error("Error fetching broker markets:", error);
    }
  };

  const openUpdateApiKeyModal = (keys) => {
    setExchangeName(keys.exchange_name === " BINANCE" ? "BINANCE" : "PAYBITO");
    setApiKeyName(keys.apiKeyName);
    setMarket(keys.marketType);
    setApiKey(keys.apiKey);
    setSecretKey(keys.secretKey);
    setApiKeyId(keys.apiKeyId);
    setOpen(true);
  };
  const handleDelete = (keys) => {
    setDeleteData(keys);
    setDeleteModal(true);
  };

  const deleteApiKey = async (keys, action) => {
    const accessToken = localStorage.getItem("access_token");

    const apiKeyName = keys.apiKeyName;
    const market = keys.marketType;
    const apiKey = keys.apiKey;
    const secretKey = keys.secretKey;
    const apiKeyId = keys.apiKeyId;
    const exchangeName = keys.exchange_name;

    const deleteAPI = {
      apiKey,
      marketType: market,
      apiKeyName,
      secretKey,
      customerId: localStorage.getItem("userId"),
      status: 1,
      apiKeyId,
      exchange_name:
        exchangeName === "BINANCE" || exchangeName === "PAYBITO"
          ? exchangeName
          : "PAYBITO",
      action: action,
    };

    try {
      const response = await axios.post(
        `${COPYTRADINGSERVICE}/apiKey/addApiKey`,
        JSON.stringify(deleteAPI),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", "API Key Deleted");
        getAllApiKeys();
        setDeleteModal(false);
        setDeleteData({});
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error deleting API Key:", error);
      showToast("error", "An unexpected error occurred.");
    }
  };
  const updateStatus = async (keys, status) => {
    const accessToken = localStorage.getItem("access_token");

    const apiKeyName = keys.apiKeyName;
    const market = keys.marketType;
    const apiKey = keys.apiKey;
    const secretKey = keys.secretKey;
    const apiKeyId = keys.apiKeyId;
    const exchangeName =
      keys.exchange_name === "BINANCE" ? "BINANCE" : "PAYBITO";

    const updateAPI = {
      apiKey,
      marketType: market,
      apiKeyName,
      secretKey,
      customerId: localStorage.getItem("userId"),
      status: status,
      apiKeyId,
      exchange_name: exchangeName,
      action: "UPDATE",
    };

    try {
      const response = await axios.post(
        `${COPYTRADINGSERVICE}/apiKey/addApiKey`,
        JSON.stringify(updateAPI),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", response.data.error.error_msg);
        getAllApiKeys();
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error deleting API Key:", error);
      showToast("error", "An unexpected error occurred.");
    }
  };

  const toggleData = async (event, keys) => {
    const isChecked = event.target.checked;
    const status = isChecked ? 1 : 0;
    setKeyStatus(status);
    updateStatus(keys, status);
  };

  const isValid = () => {
    if (
      apiKey.trim() === "" ||
      !secretKey ||
      !apiKeyName ||
      !market ||
      !exchangeName
    ) {
      return true;
    }
    return false;
  };

  return (
    <Box sx={{ px: 2, my: 2 }}>
      <Paper sx={{ px: 2 }}>
        <Box className="apikeyscontent">
          <h5>My API Keys</h5>
          <Box>
            <ContainedButton
              variant="contained"
              onClick={() => navigate("/settings")}
            >
              Create API Key
            </ContainedButton>
            <ContainedButton variant="contained" onClick={() => setOpen(true)}>
              Add API Key
            </ContainedButton>
            <ContainedButton
              variant="contained"
              startIcon={
                <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              }
              className="mx-3 backbtn"
              onClick={() => navigate("/copy-trade")}
            >
              Back
            </ContainedButton>
          </Box>
        </Box>
        <Box sx={{ overflow: "auto" }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            className="apikey_table mt-4"
          >
            <TableHead>
              <TableRow>
                {Columns.map((column, i) => (
                  <TableCell
                    key={i}
                    align={i === 3 || i === 4 || i === 5 ? "center" : "start"}
                  >
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {allApiKeys?.length !== 0 ? (
                allApiKeys
                  ?.sort((a, b) => b.apiKeyId - a.apiKeyId)
                  ?.map((keys, i) => (
                    <TableRow key={i} hover>
                      <TableCell>{keys.apiKeyName}</TableCell>
                      <TableCell>{keys.exchange_name}</TableCell>
                      <TableCell>{keys.marketType}</TableCell>
                      <TableCell align="center">{keys.apiKey}</TableCell>
                      <TableCell align="center">
                        <Switch
                          checked={keys.status === "1"}
                          onChange={(e) => toggleData(e, keys)}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: btncolor, // custom thumb color
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              {
                                backgroundColor: btncolor, // custom track color when checked
                              },
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <ContainedButton
                          variant="contained"
                          size="small"
                          onClick={() => openUpdateApiKeyModal(keys)}
                          style={{ marginRight: 8 }}
                        >
                          Edit
                        </ContainedButton>
                        <OutlinedButton
                          variant="outlined"
                          size="small"
                          onClick={() => handleDelete(keys)}
                        >
                          Delete
                        </OutlinedButton>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} className="text-center">
                    No Data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
        <ModalContent
          open={open}
          onClose={handleClose}
          title={`${apiKeyId ? "Edit" : "Add"} API Key`}
        >
          <form onSubmit={handleSubmit}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Choose Exchange</InputLabel>
              <Select
                value={exchangeName}
                onChange={(e) => setExchangeName(e.target.value)}
                label="Choose Exchange"
              >
                <MenuItem value="PAYBITO">{brokerBasicInfo?.exchange}</MenuItem>
                <MenuItem value="BINANCE">Binance</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel>Choose Market</InputLabel>
              <Select
                value={market}
                onChange={(e) => {
                  setMarket(e.target.value);
                  setBinancePopup(true);
                }}
                label="Choose Market"
              >
                <MenuItem value="">Select Market</MenuItem>
                {brokerMarkets?.spot === 1 && (
                  <MenuItem value="SPOT">Spot</MenuItem>
                )}
                {brokerMarkets?.futures === 1 && (
                  <MenuItem value="FUTURES">Futures</MenuItem>
                )}
                {/* Uncomment if OPTIONS is needed */}
                {/* {brokerMarkets?.options === 1 && (
                    <MenuItem value="OPTIONS">Options</MenuItem>
                  )} */}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              margin="normal"
              label="Enter API Key Name"
              value={apiKeyName}
              onChange={(e) => setApiKeyName(e.target.value)}
              onKeyDown={VALIDATION1}
              inputProps={{ maxLength: 30 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Enter API Key"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              onKeyDown={VALIDATION2}
              inputProps={{ maxLength: 200 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Secret Key"
              value={secretKey}
              onChange={(e) => setSecretKey(e.target.value)}
              onKeyDown={VALIDATION2}
              inputProps={{ maxLength: 200 }}
            />

            <ContainedButton
              type="submit"
              variant="contained"
              fullWidth
              disabled={isValid()}
            >
              Submit
            </ContainedButton>
          </form>
        </ModalContent>
        <ModalContent
          open={binancePopup}
          onClose={() => setBinancePopup(false)}
          title={`IP Whitelist`}
        >
          <Box
            sx={{
              px: 2,
              py: 2,
            }}
          >
            <Typography>
              Please make sure to whitelist this IP address{" "}
              <strong>52.52.35.9</strong> with your API key on the Binance site
              for Spot/Futures market.
            </Typography>
          </Box>
          <Box
            className="modal-footer"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              px: 2,
              py: 1.5,
            }}
          >
            <OutlinedButton
              variant="outlined"
              onClick={() => setBinancePopup(false)}
            >
              Close
            </OutlinedButton>
          </Box>
        </ModalContent>

        <ModalContent open={deleteModal} onClose={() => setDeleteModal(false)}>
          <p className="text-center">
            Are you sure you want to delete the API key?
          </p>

          <Box className="d-flex justify-content-center align-items-center mt-2 gap-2">
            <OutlinedButton
              variant="outlined"
              onClick={() => setDeleteModal(false)}
            >
              No
            </OutlinedButton>
            <ContainedButton onClick={() => deleteApiKey(deleteData, "DELETE")}>
              Yes
            </ContainedButton>
          </Box>
        </ModalContent>
      </Paper>
    </Box>
  );
};

export default ApiKey;
